function BikeCleanRequestTransformer(Util, jsonMapper) {

	function transform(intermediateRequest, userInput) {
		try {
			delete intermediateRequest.bikeForm;

			var bike = intermediateRequest.motorcycles[0];
			var policyHolders = intermediateRequest.policyHolders;

			delete bike.motorcycleInfo.description;
			delete bike.motorcycleInfo.goodRetailPrice;
			delete bike.motorcycleInfo.bikeType;
			delete bike.motorcycleInfo.ratingGrade;
			delete bike.motorcycleInfo.vehicleKey;
			delete bike.motorcycleInfo.enrichment;
			delete bike.accountLocation.enrichment;
			delete bike.totalAccessoriesPrice;
			delete bike.totalModificationsPrice;
			delete bike.youngestRiderDateOfBirth;

			if ( bike.riders ) {
				bike.riders.forEach(function(policyRider, index) {
					delete policyRider.rider._HTMLID;
					delete policyRider.rider._aggregator;
					delete policyRider.rider.threeYears_accidentsClaims;
					delete policyRider.rider.threeYears_accidentsClaimsDetails;
					delete policyRider.rider.threeYears_restrictedSuspendedDisqualifiedCancelled;
					delete policyRider.rider.threeYears_restrictedSuspendedDisqualifiedCancelledDetails;
					delete policyRider.rider.fiveYears_chargedOrConvicted;
					delete policyRider.rider.fiveYears_chargedOrConvictedDetails;
					delete policyRider.rider.person.noClaimBonus;
					delete policyRider.rider.person.title;
					delete policyRider.riders;
					delete policyRider.rider.isMemberOfClub;
					delete policyRider.rider.isTheMainRider;
					delete policyRider.rider.licensedToRide;
					delete policyRider.rider.motorcycleClub;
					delete policyRider.rider.yearsHeld;
					delete policyRider.rider.previousInsurer;
					delete policyRider.rider.primaryPhoneNumber;
					delete policyRider.rider.person.riders;
					delete policyRider.rider.person.address;
					delete policyRider.rider.person.fiveYears_chargedOrConvicted;
					delete policyRider.rider.person.isMainRiderMainPolicyHolder;
					delete policyRider.rider.person.postalOption;
					delete policyRider.rider.person.threeYears_accidentsClaims;
					delete policyRider.rider.person.threeYears_restrictedSuspendedDisqualifiedCancelled;

					if (index > 0) {
						delete policyRider.rider.person.hasClaim;
						delete policyRider.rider.person.hasConviction;
						delete policyRider.rider.currentInsurer;
						delete policyRider.rider.noClaimBonus;
						// delete policyRider.rider.person.primaryAddress.addressType;

						// test
						delete policyRider.rider.relationWithMainRider;
					}

				})
			}
			//

			policyHolders.forEach(function(policyHolder) {
				if ( policyHolder.contact ) {
					delete policyHolder.contact._HTMLID;
					delete policyHolder.contact.$$hashKey;
					delete policyHolder.contact._aggregator;

					delete policyHolder.contact.anyInfringements;
					delete policyHolder.contact.anyLostLicences;
					delete policyHolder.contact.riders;
					delete policyHolder.contact.MaxNoClaimBonus;
					delete policyHolder.contact.noClaimBonus;
					delete policyHolder.contact.numberOfOtherRiders;
					delete policyHolder.contact.provisionalLicence;
					delete policyHolder.contact.title;
					delete policyHolder.contact.youngestRider;
					delete policyHolder.contact.youngestRiderDob;
					delete policyHolder.contact.youngestRiderGender;
					delete policyHolder.contact.address;
					delete policyHolder.contact.postalOption;
					delete policyHolder.contact.primaryPhoneNumber;
					delete policyHolder.contact.fiveYears_chargedOrConvicted;
					delete policyHolder.contact.fiveYears_chargedOrConvictedDetails;
					delete policyHolder.contact.isMainRiderMainPolicyHolder;
					delete policyHolder.contact.threeYears_accidentsClaims;
					delete policyHolder.contact.threeYears_accidentsClaimsDetails;
					delete policyHolder.contact.threeYears_restrictedSuspendedDisqualifiedCancelled;
					delete policyHolder.contact.threeYears_restrictedSuspendedDisqualifiedCancelledDetails;
					delete policyHolder.contact.primaryAddress.enrichment;
				}

				if (!!policyHolder.contact.contactType && policyHolder.contact.contactType === 'person') {
					delete policyHolder.contact.authorisedPersons;
				}
				if (!!policyHolder.contact.authorisedPersons) {
					delete policyHolder.contact.dateOfBirth;
					delete policyHolder.contact.firstName;
					delete policyHolder.contact.lastName;
				}
			});


			if ( intermediateRequest.motorcycles[0].sumInsuredType !== 'agreed' ) {
				delete intermediateRequest.motorcycles[0].sumInsuredAmount;
			}

			if ( ! intermediateRequest.email )
				delete intermediateRequest.email ;

			}
		catch (ex) {
			console.log(ex);
		}	
		return intermediateRequest;
	}

	return {
		transform: transform
	}
}
